<template>
    <v-dialog
        v-model="show"
        kind="modal"
        status="primary"
        class="v-dialog--robot-associate"
        :title="typeof title === 'string' ? $t(title) : title"
        :confirm-disabled="confirmDisabled"
        @confirm="confirm"
    >
        <div v-if="model === 'form'" class="form">
            <v-form
                ref="form"
                size="small"
                kind="desc"
                @submit="submit"
            >
                <v-form-item
                    :rules="robotRules"
                    name="robotName"
                    :label="$t('关联机器人')"
                    error-placement="bottom-left"
                    :required="$t('请选择要关联的机器人')"
                >
                    <v-select
                        ref="select"
                        v-model="robotSelect"
                        :placeholder="$t('请选择')"
                        :options="robotList"
                        :max-height="264"
                        popper-clazz="robot-associate-select"
                        is-search
                        @search="input"
                        @btnSearchAction="search"
                        @visibleChange="visibleChange"
                    >
                        <template slot="customOptions">
                            <slot name="customOptions" />
                        </template>
                        <template slot="item" slot-scope="props">
                            <span class="v-select-list__inner list-item">
                                <HighlightText class="list-item-name" :text="props.item.text" :keywords="keywords" />
                                <span v-if="checkRobotInvalid(props.item)" class="list-item-error">{{ props.item.meta.robotErrReason }}</span>
                            </span>
                        </template>
                    </v-select>
                </v-form-item>
            </v-form>
        </div>
        <div v-else class="list">
            <v-input
                v-model="keywords"
                kind="search"
                :placeholder="$t('机器人名称')"
                class="list-input"
                @search="fetchList"
            />
            <v-select-list
                v-model="robotSelect"
                :options="robotList"
                class="list-content"
            >
                <template slot="item" slot-scope="props">
                    <span class="v-select-list__inner list-item">
                        <HighlightText class="list-item-name" :text="props.item.text" :keywords="keywords" />
                        <span v-if="checkRobotInvalid(props.item)" class="list-item-error">{{ props.item.meta.robotErrReason }}</span>
                    </span>
                </template>
            </v-select-list>
        </div>
    </v-dialog>
</template>

<script>
import HighlightText from '@/components/highlight-text';
const DISABLE_CLICK_BIG_ROBOT_STATUS = [2, 10, 8];
export default {
    name: 'AssociateRobot',
    components: {
        HighlightText,
    },
    props: {
        model: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '关联大模型机器人',
        },
    },
    data() {
        return {
            show: false,
            robotSelect: 0,
            robotList: [],
            keywords: '',
            oldSelect: '',
            robotRules: [
                {
                    required: true,
                    message: this.$t('请选择要关联的机器人'),
                    trigger: 'submit',
                },
            ],
        };
    },
    computed: {
        confirmDisabled() {
            return !this.robotSelect || this.robotSelect === this.oldSelect;
        },
    },
    created() {
        this.fetchList();
    },
    methods: {
        visibleChange() {
            if (this.model === 'form')  this.$refs.select.searchKeyword = '';
        },
        input(value) {
            this.keywords = value;
        },
        checkRobotInvalid(robotItem) {
            if (!robotItem) return false;
            return DISABLE_CLICK_BIG_ROBOT_STATUS.includes(robotItem.meta.robotStatus);
        },
        search(val) {
            this.keywords = val;
            this.fetchList();
        },
        fetchList() {
            // frobotchatgpttype eq 1    (eq 0普通机器人，eq 1大模型机器人)
            let filterStr = 'sku.frobotactiveflg in [0,1] and frobotchatgpttype eq 1';
            if (this.keywords) {
                // 后台不支持/%_这三个字符的搜索
                const target = this.keywords.replace(/[/|%|_]/g, '');
                filterStr += ` and frobotname has '${target}'`;
            }
            filterStr += '&order=frobotcreatetime desc';
            this.$ajax.gatewayGet(`/v1/robotConf/robot/list?kfext=0&filter=${encodeURI(filterStr)}`).then((res) => {
                this.robotList = res.data.robotInfo.map(item => ({
                    value: item.id,
                    text: item.name,
                    disabled: this.checkRobotInvalid(item),
                    ...item,
                }));
            })
                .catch((err) => {
                    this.$message.error(err.message || this.$t('获取页面数据失败'));
                });
        },
        open(robotId) {
            this.oldSelect = robotId;
            this.robotSelect = robotId;
            this.show = true;
            this.fetchList();
        },
        close() {
            this.show = false;
        },
        submit(e) {
            e.preventDefault();
            this.show = false;
            this.$emit('submit', this.robotSelect);
        },
        confirm(e) {
            if (this.model === 'form') {
                e.preventDefault();
                this.$refs?.form.submit();
            } else {
                this.$emit('confirm', this.robotSelect);
            }
        },
    },
};
</script>
<style lang="less">
.robot-associate-select  {
    .list-item {
        display: flex;
        max-width: 100%;
        &-error {
            color: var(--color-error-disable);
            flex: 0 0 auto;
        }
        &-name {
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .v-select-list__customer .is-disabled {
        color: var(--color-text-disable);
        cursor: not-allowed;
    }
}
</style>
<style lang="less" scoped>
.v-dialog--robot-associate {
    .form {
        width: 546px;
        /deep/ .v-select {
            width: 100%;
        }
        /deep/ .v-descriptions--content {
            position: unset;
            width: 100%;
        }
        /deep/ .v-description-item {
            margin: 0;
            width: 100% !important;
        }
        /deep/ .v-select--search-input {
            position: unset;
            text-align: left;
            margin-top: 0 !important;
        }
        /deep/ .is-hidden {
            height: 0;
            box-sizing: border-box;
            padding: 0;
        }
    }
    .list {
        text-align: left;
        height: 342px;
        width: 352px;
        &-input {
            width: 100%;
        }

        &-content {
            max-height: calc( 100% - 40px);
            overflow-y: auto;
        }
        &-item {
            display: flex;
            max-width: 100%;
            &-error {
                color: var(--color-error-disable);
                flex: 0 0 auto;
            }

            &-name {
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
}
</style>
